module.exports = __webpack_public_path__ + "img/back8.55e64cdf.png";